<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="370">
    <v-card>
        <v-card-title>
           <v-icon color="primary" left>mdi-file-plus</v-icon> TRUCK 
           <v-spacer/>
           <v-icon @click="emitToParent('close')">mdi-close</v-icon>
        </v-card-title>
        <v-card-text>
            <v-row>
               <v-col cols="12">
                <v-form
                    ref="form"
                    class="mt-1 pa-1"
                    v-model="valid"
                    lazy-validation
                  >
                    <v-text-field
                    v-model="truck.name"
                    label="Body Type"
                    :rules="textRules"
                    dense
                    outlined
                    required
                    ></v-text-field>
                   <v-text-field
                    v-model="truck.description"
                    label="Description"
                    dense
                    outlined
                    ></v-text-field>
                     <v-text-field
                    v-model="truck.plate_number"
                    label="Plate Number"
                    dense
                    outlined
                    ></v-text-field>
                        <v-text-field
                    v-model="truck.capacity"
                    label="Area capacity"
                    persistent-hint
                    hint="by Cubic Meter"
                    dense
                    outlined
                    ></v-text-field>
                      <v-text-field
                    v-model="truck.weight"
                    label="Weight"
                    dense
                    outlined
                      persistent-hint
                    hint="by Kilogram"
                    ></v-text-field>
                    
                </v-form>
               </v-col>
                
            </v-row>
        </v-card-text>
        <v-card-actions>
                <v-btn color="warning" small  text @click="emitToParent('close')">CLOSE</v-btn>
            <v-spacer></v-spacer>
            <v-btn  small color="success"  depressed  @click="validate()">{{BTN_TEXT}}</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    state: {
        type: String,
        default: "new"
    },
    item: {
      type: Object,
      default: ()=>{}
    }
  },
  data: () => ({
      valid: true,
      textRules: [
        v => !!v || 'Field is required'
      ],
      discounts:[],
      discount:{},
       truck:{}
  }),
  computed: {
      BTN_TEXT() {
          if(this.state == 'new')
            return "ADD"
         else 
            return "SAVE"
      }
  },
  watch: {
    show(v) {
      if(v){
        if(this.state != 'new') {
        this.truck=this.item
        } else {
           this.truck={}
        }
      } 
    }
  },
  methods: {
      validate () {
        if (this.$refs.form.validate()) {
          if(this.state == 'new') {
            this.Add()
          } else {
            this.Save()
          }
        }
      },
    emitToParent (action) {
       this.$emit('DialogEvent',{action:action})
    },
    Save() {
        this.$http.post("truck/update", this.truck).then(response => {
             this.GET_RESPONSE(response)
           this.$emit('DialogEvent', {action: "close"})
          }).catch(e => {
            console.log(e.data)
        })
    },
    Add() {
        this.$http.post("truck/add", this.truck).then(response => {
           this.GET_RESPONSE(response)
           this.$emit('DialogEvent', {action: "close"})
          }).catch(e => {
            console.log(e.data)
        })
    }
  }
}
</script>
